import React from "react";
import MaterialTable from '@material-table/core';
import { useHistory } from 'react-router-dom';
import { ExportCsv } from "@material-table/exporters";


function SearchResults(props) {
    let history = useHistory();
    return (
        <div className="search-results">
            {props.targetPeople && <MaterialTable
                columns={[
                    { title: "ID", field: "id" },
                    { title: "Name", field: "person_name"}
                ]}
                data={props.data.persons}
                options={{
                    columnsButton: false,
                    pageSize: 10,
                    search: false,
                    exportAllData: true,
                    exportMenu: [
                        {
                            label: "Export CSV",
                            exportFunc: (cols, datas) => ExportCsv(cols, datas, "persons"),
                        },
                    ],
                    headerStyle: {
                        backgroundColor: '#1b437e',
                        color: '#FFF'
                    },
                }}
                title={<h4>Persons</h4>}
                onPageChange={e => {}}
                onRowClick={((evt, selectedRow) => {
                    history.push('/person/' + selectedRow.id)
                })}
            />}

            {props.targetWorks && <MaterialTable
                columns={[
                    { title: "ID", field: "id" },
                    { title: "Title", field: "title"},
                    { title: "Author", field: "author" },
                    { title: "Authorial status", field: "authorial_status" }
                ]}
                data={props.data.works}
                options={{
                    columnsButton: false,
                    pageSize: 10,
                    search: false,
                    exportAllData: true,
                    exportMenu: [
                        {
                            label: "Export CSV",
                            exportFunc: (cols, datas) => ExportCsv(cols, datas, "persons"),
                        },
                    ],
                    headerStyle: {
                        backgroundColor: '#1b437e',
                        color: '#FFF'
                    },
                }}
                title={<h4>Works</h4>}
                onPageChange={e => {}}
                onRowClick={((evt, selectedRow) => {
                    history.push('/work/' + selectedRow.id)
                })}
            />}

            {props.targetPlaces && <MaterialTable
                columns={[
                    { title: "id", field: "id" },
                    { title: "name", field: "place_name"}
                ]}
                data={props.data.places}
                options={{
                    columnsButton: false,
                    pageSize: 10,
                    search: false,
                    exportAllData: true,
                    exportMenu: [
                        {
                            label: "Export CSV",
                            exportFunc: (cols, datas) => ExportCsv(cols, datas, "persons"),
                        },
                    ],
                    headerStyle: {
                        backgroundColor: '#1b437e',
                        color: '#FFF'
                    },
                }}
                title={<h4>Places</h4>}
                onPageChange={e => {}}
                onRowClick={((evt, selectedRow) => {
                    history.push('/place/' + selectedRow.id)
                })}
            />}
        </div>
    );
}

export default SearchResults;